import { gql } from "@apollo/client";

//TODO only "startNextFeeding" excists in internal instead of "byLocation" and "bySystem"
export const START_NEXT_FEEDING_BY_LOCATION = gql`
  mutation StartNextFeeding($domain: String!, $locationids: [Int!]!) {
    location {
      startNextFeeding(domain: $domain, locationids: $locationids) {
        code
        message
        success
        id
      }
    }
  }
`
//TODO ------||------
export const START_NEXT_FEEDING_BY_SYSTEM = gql`
  mutation StartNextFeeding($domain: String!, $feedcurveid: Int!, $systemid: Int!) {
    system {
      startNextFeeding(domain: $domain, feedcurveid: $feedcurveid, systemid: $systemid) {
        code
        message
        success
        id
      }
    }
  }
`

export interface BaseStartFeedingMutationResponse {
  code: string;
  success: boolean;
  message: string;
  id?: number
}

export interface StartNextFeedingByLocationResponse {
  location: {
    startNextFeeding: BaseStartFeedingMutationResponse[]
  }
}

export interface StartNextFeedingBySystemResponse {
  system: {
    startNextFeeding: BaseStartFeedingMutationResponse[]
  }
} 